import Vuex from 'vuex';
import Vue from 'vue';
import menuModule from './menu';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        menu: menuModule
    }
});
